// ui/landingPage/calibrationLogsTab/uiLandingPageCalibrationLogsTabActions.js

import { CALIBRATION_LOG_BOOK_VIEWS } from "./uiLandingPageCalibrationLogsTabState";

export const makeCalibrationLogsTabUIActions = (set, get) => ({
  setCurrentView: (view) =>
    set((s) => ({
      calibrationLogsTabUI: { ...s.calibrationLogsTabUI, currentView: view },
    })),
  setActiveTab: (tab) =>
    set((s) => ({
      calibrationLogsTabUI: { ...s.calibrationLogsTabUI, activeTab: tab },
    })),
  showTableView: () =>
    set((s) => ({
      calibrationLogsTabUI: {
        ...s.calibrationLogsTabUI,
        currentView: CALIBRATION_LOG_BOOK_VIEWS.TABLE,
      },
    })),
  showCreateFormView: () =>
    set((s) => ({
      calibrationLogsTabUI: {
        ...s.calibrationLogsTabUI,
        currentView: CALIBRATION_LOG_BOOK_VIEWS.CREATE_FORM,
      },
    })),
  showBookFormView: () =>
    set((s) => ({
      calibrationLogsTabUI: {
        ...s.calibrationLogsTabUI,
        currentView: CALIBRATION_LOG_BOOK_VIEWS.BOOK_FORM,
      },
    })),
});
